import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const S = {
  EmptyList: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 8px;
    height: 100%;

    &.empty-list__student {
      > button {
        margin-top: 24px;
      }
    }

    p {
      color: ${colors.gray.$900};
      text-align: center;
    }

    .button-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-top: 24px;
    }

    .desc {
      margin-top: 8px;
      ${typo.caption01};
      color: ${colors.gray.$700};

      p {
        text-align: center;
      }
    }

    .empty-notification-image {
      width: 80px;
      height: 80px;
    }
    .empty-notification-text {
      color: ${colors.gray.$700};
      ${typo.body02};
      margin-top: 10px;
    }
  `,
}

export default S
